import { IRIS_PAGE_LOAD_REQUEST } from '../actionTypes/IrisActionTypes';

export const getIrisTemplateData = (
    params,
    aggregateAPI,
    postProcessor,
    irisFallbackEnabled,
    irisFallbackPreferences,
    redirectAction,
    disableIrisCall,
    isFallingBackAfterCMFailed = false,
    initialLoad = true,
    showErrorPage = true
) => ({
    type: IRIS_PAGE_LOAD_REQUEST,
    payload: {
        params,
        aggregateAPI,
        postProcessor,
        irisFallbackEnabled,
        irisFallbackPreferences,
        redirectAction,
        disableIrisCall,
        isFallingBackAfterCMFailed,
        initialLoad,
        showErrorPage,
    },
});

export default {
    getIrisTemplateData,
};
